import React, { ReactElement, useState } from "react"
import HelpOutlineIcon from "@material-ui/icons/HelpOutline"
import ContactMailIcon from "@material-ui/icons/ContactMail"
import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Typography,
} from "@material-ui/core"
import { useSharedNavStyles } from "../_config/style"

export default function Help(): ReactElement {
	const sharedStyle = useSharedNavStyles()
	const [open, setOpen] = useState(false)
	const [openContact, setOpenContact] = useState(false)

	const handleClickOpen = (): void => setOpen(true)
	const handleClose = (): void => setOpen(false)

	const handleClickOpenContact = (): void => setOpenContact(true)
	const handleCloseContact = (): void => setOpenContact(false)

	return (
		<>
			<Button
				className={sharedStyle.button}
				color="inherit"
				startIcon={<HelpOutlineIcon />}
				onClick={handleClickOpen}
			>
				Pomoć
			</Button>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="help-dialog-title"
				aria-describedby="help-dialog-description"
			>
				<DialogTitle id="help-dialog-title">Pomoć</DialogTitle>
				<DialogContent>
					<DialogContentText
						id="help-dialog-description"
						className="content-area"
					>
						<Typography style={{ fontWeight: "bold" }}>
							Prijavite problem
						</Typography>
						<Typography>
							Molimo prijavite tehničke probleme na{" "}
							<a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL || ""}`}>
								{process.env.REACT_APP_SUPPORT_EMAIL || ""}
							</a>
							.
						</Typography>
						<Typography style={{ marginTop: 6 }}>
							Naš standard usluge rešavanja je obično jedan radni dan.
						</Typography>
						<Typography style={{ fontWeight: "bold", marginTop: 12 }}>
							Help and tips
						</Typography>
						<Typography>Možda neka baza znanja....</Typography>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary" autoFocus>
						Zatvori
					</Button>
				</DialogActions>
			</Dialog>

			<Button
				className={sharedStyle.button}
				color="inherit"
				startIcon={<ContactMailIcon />}
				onClick={handleClickOpenContact}
			>
				Kontakt
			</Button>
			<Dialog
				open={openContact}
				onClose={handleCloseContact}
				aria-labelledby="help-dialog-title"
				aria-describedby="help-dialog-description"
			>
				<DialogTitle id="help-dialog-title">Kontakt</DialogTitle>
				<DialogContent>
					<DialogContentText
						id="help-dialog-description"
						className="content-area"
					>
						<Typography style={{ fontWeight: "bold" }}>
							Napravi kontakt formu ili dodaj kontakt podatke!
						</Typography>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseContact} color="primary" autoFocus>
						Zatvori
					</Button>
				</DialogActions>
			</Dialog>
		</>
	)
}
